// SPDX-License-Identifier: AGPL-3.0-or-later

import GeoIP from '@app/features/app/state/GeoIP';
import DeveloperOptions from '@app/features/devtools/state/DeveloperOptions';

interface NSFWGeoContext {
	countryCode: string | null;
	regionCode: string | null;
}
export function getEffectiveNSFWGeoContext(): NSFWGeoContext {
	if (DeveloperOptions.mockInUK) {
		return {countryCode: 'GB', regionCode: null};
	}
	return {
		countryCode: GeoIP.countryCode,
		regionCode: GeoIP.regionCode,
	};
}
export function isAgeVerificationAvailableInRegion(): boolean {
	const {countryCode} = getEffectiveNSFWGeoContext();
	return countryCode === 'GB';
}
